import {CommonModule} from '@angular/common';
import {AccountComponent} from './components/account/account.component';
import {PrlAccountRoutingModule} from './prl-account-routing.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgModule} from '@angular/core';
import {MatSelectModule} from '@angular/material/select';
import {ReactiveFormsModule} from '@angular/forms';
import {MxButtonModule, MxFormModule, MxGridModule} from 'mx-core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MxInfoTooltipModule} from '../../../../../mx-core/src/lib/modules/mx-info-tooltip/mx-info-tooltip.module';
import {MatInputModule} from '@angular/material/input';
import {PrlAddContactComponent} from './components/contact/prl-add-contact/prl-add-contact.component';
import {PrlEditContactComponent} from './components/contact/prl-edit-contact/prl-edit-contact.component';
import {PrlManagerInfoComponent} from './components/manager/prl-manager-info/prl-manager-info.component';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {PrlDocumentsComponent} from './components/document/prl-documents/prl-documents.component';
import {PrlAddDocumentComponent} from './components/document/prl-add-document/prl-add-document.component';
import {PrlContactsComponent} from './components/contact/prl-contacts/prl-contacts.component';
import {SharedModule} from '../../shared/shared.module';
import {PrlLanguageModule} from '../prl-language/prl-language.module';
import {PrlPanelComponent} from '../../shared/components/prl-panel/prl-panel.component';

@NgModule({
    declarations: [
        AccountComponent,
        PrlContactsComponent,
        PrlAddContactComponent,
        PrlEditContactComponent,
        PrlManagerInfoComponent,
        PrlDocumentsComponent,
        PrlAddDocumentComponent,
    ],
    imports: [
        CommonModule,
        PrlAccountRoutingModule,
        MxButtonModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatListModule,
        MatSelectModule,
        MatInputModule,
        MxGridModule,
        MxFormModule,
        MxButtonModule,
        ReactiveFormsModule,
        MxInfoTooltipModule,
        MatCheckboxModule,
        SharedModule,
        PrlLanguageModule,
        PrlPanelComponent,
    ]
})
export class PrlAccountModule {

}
